export default {
  install(Vue) {
    const bus = new Vue()

    Object.defineProperty(Vue.prototype, '$bus', {
      get: function () {
        return bus
      },
      set: function (evt) {
        if (typeof evt === 'string') evt = [evt]
        bus.$emit.apply(bus, evt)
      },
    })

    Vue.mixin({
      created: function () {
        const $bus = this.$options.$bus
        this.$busListeners = {}
        for (const name in $bus) {
          this.$busListeners[name] = $bus[name].bind(this)
          bus.$on(name, this.$busListeners[name])
        }
      },
      beforeDestroy: function () {
        for (const name in this.$busListeners) bus.$off(name, this.$busListeners[name])
        this.$busListeners = null
      },
    })
  },
}
